import * as sipPhoneStatuses from './constants/statuses';
import { SipPhoneContext } from './context/SipPhoneContext';
import SipPhoneProvider from './SipPhoneProvider';

export default SipPhoneProvider;

export { sipPhoneStatuses, SipPhoneContext };
